import { combineReducers } from 'redux';
import { createSlice } from '@reduxjs/toolkit';
import appStatusReducer from 'ContentEditorUI/redux/reducers/appStatusReducer';
// @ts-expect-error not typed
import baseSettingsReducer from 'ContentEditorUI/redux/reducers/settings/baseSettingsReducer';
// @ts-expect-error not typed
import contentSchemaReducer from 'ContentEditorUI/redux/reducers/contentSchemaReducer';
// @ts-expect-error not typed
import panesVisitStatusReducer from 'ContentEditorUI/redux/reducers/panesVisitStatusReducer';
import portalReducer from 'ContentEditorUI/redux/reducers/portalReducer';
// @ts-expect-error not typed
import usersReducer from 'ContentEditorUI/js/redux/reducers/usersReducer';
import userAttributesReducer from 'ContentEditorUI/redux/reducers/userAttributesReducer';
// @ts-expect-error not typed
import locallyCachedSettingsReducer from 'ContentEditorUI/redux/reducers/locallyCachedSettingsReducer';
import { sidebarStateReducer } from 'ContentEditorUI/redux/reducers/sidebarStateReducer';
// @ts-expect-error not typed
import selectionReducer from 'ContentEditorUI/redux/reducers/selectionReducer';
// @ts-expect-error not typed
import iframesReducer from 'ContentEditorUI/redux/reducers/iframesReducer';
import brandSettingsReducer from 'ContentEditorUI/redux/reducers/brandSettingsReducer';
import sectionsReducer from 'ContentEditorUI/redux/reducers/sectionsReducer';
import modalReducer from 'ContentEditorUI/redux/reducers/modalReducer';
// @ts-expect-error not typed
import createCollaborationSidebarReducer from 'ContentEditorUI/redux/reducers/createCollaborationSidebarReducer';
import locationReducer from 'ContentEditorUI/redux/reducers/locationReducer';
import { categorizationReducer } from 'ContentEditorUI/redux/reducers/categorizationReducer';
import immutableToImmerReducer from 'ContentEditorUI/redux/reduxReducerDiffer';
import { runDiffsOnFiftyPercentOfAppLoads } from 'ContentEditorUI/redux/reducers/reduxReducerDifferUtils';

// Modules
// @ts-expect-error not typed
import justSavedModuleReducer from 'ContentEditorUI/redux/reducers/justSavedModuleReducer';
// @ts-expect-error not typed
import editSidebarReducer from 'ContentEditorUI/redux/reducers/editSidebarReducer';
import moduleSchemaReducer from '../data/reducers/moduleSchemaReducer';
import moduleReducer, { compareModuleReducerSlices, moduleReducerAsJSObject } from 'ContentEditorUI/redux/reducers/moduleReducer';
import createUndoableModuleReducer, { createUndoableModuleReducerAsPOJO } from 'ContentEditorUI/redux/reducers/undoableModuleReducer';
// @ts-expect-error not typed
import moduleErrorReducer from 'ContentEditorUI/redux/reducers/moduleErrorReducer';
import deleteRequestReducer from 'ContentEditorUI/redux/reducers/deleteRequestReducer';
import cloneRequestReducer from 'ContentEditorUI/redux/reducers/cloneRequestReducer';

// Content
import resources from 'ContentData/reducers/Resources';
// @ts-expect-error not typed
import editingInfoReducer from 'ContentEditorUI/redux/reducers/editingInfoReducer';
import saveDataReducer from 'ContentEditorUI/redux/reducers/saveDataReducer';
import abTestReducer from 'ContentEditorUI/redux/reducers/abTestReducer';
import accountVerificationStatusReducer from 'ContentEditorUI/redux/reducers/accountVerificationStatusReducer';
import contentDataReducer from 'ContentEditorUI/redux/reducers/contentReadOnlyDataReducer';
// @ts-expect-error not typed
import layoutDataReducer from 'ContentEditorUI/redux/reducers/layoutDataReducer';
import languageReducer from 'ContentEditorUI/redux/reducers/languageReducer';
// @ts-expect-error not typed
import hardSavedContentModelReducer from 'ContentEditorUI/redux/reducers/contentModel/hardSavedContentModelReducer';
import styleBreakpointsReducer from 'ContentEditorUI/redux/reducers/styleBreakpointsReducer';
import contentAssetsReducer from 'ContentEditorUI/redux/reducers/contentAssetsReducer';
// @ts-expect-error not typed
import optimizationsReducer from 'ContentEditorUI/redux/reducers/optimizationsReducer';
import inpageOptimizationsReducer from 'ContentEditorUI/redux/reducers/inpageOptimizationReducer';
import headerReducer from 'ContentEditorUI/redux/reducers/headerReducer';
// @ts-expect-error not typed
import formStatusReducer from 'ContentEditorUI/redux/reducers/formStatusReducer';

// Smart View
import smartViewReducer from 'ContentEditorUI/redux/reducers/smartViewReducer';

// Inpage Editor
// @ts-expect-error not typed
import inpageReducer from 'ContentEditorUI/redux/reducers/inpageReducer';
import inpageModals from 'tinymce-plugins/reducers/InpageModals';
import siteSettingsReducer from 'ContentEditorUI/redux/reducers/siteSettingsReducer';
import portalDomainsReducer from 'ContentEditorUI/redux/reducers/portalDomainsReducer';
// @ts-expect-error not typed
import templateInfoReducer from 'ContentEditorUI/redux/reducers/templateInfoReducer';
import themeReducer from 'ContentEditorUI/redux/reducers/themeReducer';
// @ts-expect-error not typed
import uploadedFeaturedImagesReducer from 'ContentEditorUI/redux/reducers/uploadedFeaturedImagesReducer';
// @ts-expect-error not typed
import testFlagsReducer from 'ContentEditorUI/redux/reducers/testFlagsReducer';
import baseContentModelReducer, { baseContentModelReducerAsJSObject } from 'ContentEditorUI/redux/reducers/contentModel/baseContentModelReducer';
// Instance editing
import { structuredContent } from 'structured-content-lib/redux/reducers/index';
// Revision history
import revisionHistoryReducer from 'structured-content-lib/redux/reducers/revisionHistoryReducer';
// @ts-expect-error not typed
import createRequestStatesReducer from 'ContentEditorUI/redux/reducers/createRequestStatesReducer';
// Content assistant
import contentAssistantReducer from 'ContentEditorUI/redux/reducers/contentAssistantReducer';
// @ts-expect-error not typed
import Notifications from 'ReduxMessenger/reducers/Notifications';
import { authName, authReducer } from '../data/auth';
// @ts-expect-error not typed yet
import { enableModuleReducerDiffing } from 'ContentEditorUI/utils/moduleReducerUtils';
import { gate } from 'hub-http/gates';
const extraInitialState = createSlice({
  name: 'extraInitialState',
  initialState: {},
  reducers: {}
});
enableModuleReducerDiffing();
const diffedUndoableModuleReducer = immutableToImmerReducer(createUndoableModuleReducer(moduleReducer),
// @ts-expect-error getting some weird TS errors with immutable.
// Ignoring the error for now as this will be temporary
createUndoableModuleReducerAsPOJO(moduleReducerAsJSObject), {
  reducerName: 'modules',
  reducerToReturn: {
    type: 'gated',
    gateName: gate('ContentEditorUI:ImmerModuleSelectors')
  },
  prodConfig: {
    computeDiffOnProd: 'conditionally',
    condition: runDiffsOnFiftyPercentOfAppLoads
  },
  serializeImmutableState: immutableState => immutableState.get('present').toJS(),
  computeStateDiff: (immutablePresentState, immerUndoableState) => compareModuleReducerSlices(immutablePresentState, immerUndoableState.present)
});
export const rootReducer = combineReducers({
  [authName]: authReducer,
  structuredContent,
  // Reducers for scalable editor
  abTest: abTestReducer,
  baseModalSettings: baseSettingsReducer,
  accountVerificationStatus: accountVerificationStatusReducer,
  appStatus: appStatusReducer,
  brandSettings: brandSettingsReducer,
  categorizations: categorizationReducer,
  cloneRequest: cloneRequestReducer,
  collaborationSidebar: createCollaborationSidebarReducer(),
  contentAssets: contentAssetsReducer,
  contentAssistant: contentAssistantReducer,
  contentModel: immutableToImmerReducer(baseContentModelReducer, baseContentModelReducerAsJSObject, {
    reducerName: 'contentModel',
    reducerToReturn: {
      type: 'gated',
      gateName: 'ContentEditorUI:ImmerContentModel'
    },
    prodConfig: {
      computeDiffOnProd: 'conditionally',
      condition: runDiffsOnFiftyPercentOfAppLoads
    }
  }),
  contentReadOnlyData: contentDataReducer,
  contentSchema: contentSchemaReducer,
  deleteRequest: deleteRequestReducer,
  editingInfo: editingInfoReducer,
  editSidebar: editSidebarReducer,
  extraInitialState: extraInitialState.reducer,
  formStatus: formStatusReducer,
  hardSavedContentModel: hardSavedContentModelReducer,
  header: headerReducer,
  iframes: iframesReducer,
  inpageData: inpageReducer,
  inpageModals,
  inpageOptimizationState: inpageOptimizationsReducer,
  justSavedModule: justSavedModuleReducer,
  languages: languageReducer,
  layoutData: layoutDataReducer,
  locallyCachedSettings: locallyCachedSettingsReducer,
  modals: modalReducer,
  moduleErrors: moduleErrorReducer,
  modules: diffedUndoableModuleReducer,
  moduleSchemas: moduleSchemaReducer,
  notifications: Notifications,
  optimizationState: optimizationsReducer,
  panesVisitStatus: panesVisitStatusReducer,
  portal: portalReducer,
  portalDomains: portalDomainsReducer,
  resources,
  revisionHistory: revisionHistoryReducer,
  requestStates: createRequestStatesReducer(),
  saveData: saveDataReducer,
  sections: sectionsReducer,
  selection: selectionReducer,
  sidebarState: sidebarStateReducer,
  siteSettings: siteSettingsReducer,
  smartView: smartViewReducer,
  styleBreakpoints: styleBreakpointsReducer,
  templateInfo: templateInfoReducer,
  theme: themeReducer,
  testFlags: testFlagsReducer,
  uploadedFeaturedImages: uploadedFeaturedImagesReducer,
  userAttributes: userAttributesReducer,
  users: usersReducer,
  __location: locationReducer
});